export const drawerItemsMain = [
  {
    key: "Stocks",
    title: "stock",
    routes: [{ nav: "Stocks", routeName: "Stocks", title: "stock" }],
  },
  {
    key: "Products",
    title: "searchProduct",
    routes: [{ nav: "Products", routeName: "Products", title: "product" }],
  },
  {
    key: "CustomerStatus",
    title: "customerStatus",
    routes: [
      {
        nav: "CustomerStatus",
        routeName: "CustomerStatus",
        title: "customerStatus",
      },
    ],
  },
  // {
  //   key: "CustomerOrder",
  //   title: "Customer Order",
  //   routes: [{ nav: "CustomerOder", routeName: "CustomerOrder", title: "Customer Order" }],
  // },
];
